

















// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";

export default defineComponent({
	props:{
		text:{
			type:String,
			default:""
		}
	},
	setup(){
		return {};
	}
});

